import useResidentHouseholdId from "@/src/modules/core/hooks/use-resident-household-id";
import useResidentMembership from "@/src/modules/core/hooks/use-resident-membership";
import {useStoredUserProperty} from "@/src/modules/core/store/user-property";
import useHousehold from "@/src/modules/households/hooks/use-household";
import {
  getHouseholdOccupantMembership,
  getHouseholdOwnerMembership,
} from "@/src/modules/households/lib/household-membership";

import {
  shouldHideOwnerSafelistingCreate,
  shouldHideResidentHomeTenantOperationalData,
} from "../lib/resident-home-owner-tenant-data";

function useOwnerTenantGateArgs() {
  const userProperty = useStoredUserProperty();
  const membership = useResidentMembership();
  const householdId = useResidentHouseholdId();
  const isLandlordMembership = Boolean(membership?.is_owner && !membership.is_occupant);
  const {household, isPending} = useHousehold(householdId, {
    enabled: Boolean(householdId && isLandlordMembership),
  });

  return {
    membership,
    property: userProperty,
    householdPending: Boolean(householdId && isLandlordMembership) && isPending,
    occupant: getHouseholdOccupantMembership(household?.memberships),
    owner: getHouseholdOwnerMembership(household?.memberships),
  };
}

export function useResidentHomeOwnerTenantGates() {
  const args = useOwnerTenantGateArgs();
  const hideTenantData = shouldHideResidentHomeTenantOperationalData(args);
  const hideSafelistingCreate = shouldHideOwnerSafelistingCreate(args);

  return {
    hideTenantData,
    hideSafelistingCreate,
  };
}

export function useHideResidentHomeTenantData(): boolean {
  const args = useOwnerTenantGateArgs();
  return shouldHideResidentHomeTenantOperationalData(args);
}

export function useHideOwnerSafelistingCreate(): boolean {
  const args = useOwnerTenantGateArgs();
  return shouldHideOwnerSafelistingCreate(args);
}
